import { render, staticRenderFns } from "./Project-404.vue?vue&type=template&id=2e2363a9&scoped=true"
import script from "./Project-404.vue?vue&type=script&lang=js"
export * from "./Project-404.vue?vue&type=script&lang=js"
import style0 from "./Project-404.vue?vue&type=style&index=0&id=2e2363a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2363a9",
  null
  
)

export default component.exports